export const cardComponentsList = {
  AI_CARD: "ai_card",
  LEAD_TABLE: "lead_table",
  CONTACT_TABLE: "contact_table",
  COMPANY_TABLE: "company_table",
  CUSTOMER_TABLE: "customer_table",
  DEAL_TABLE: "deal_table",
  RECOMMENDED_LEADS_TABLE: "recommended_leads_table",
  ANALYTICS: "analytics",
  TASK_TABLE: "task_table",
  ALERT_STREAM: "alert_stream",
  CRM_TASK_TABLE: "crm_task_table",
};

export const componentKeyToEntityTypeMapping = {
  [cardComponentsList.LEAD_TABLE]: "lead",
  [cardComponentsList.CONTACT_TABLE]: "contact",
  [cardComponentsList.COMPANY_TABLE]: "company",
  [cardComponentsList.CUSTOMER_TABLE]: "customers",
  [cardComponentsList.DEAL_TABLE]: "deal",
  [cardComponentsList.CRM_TASK_TABLE]: "crm_tasks",
};

export const entityEndpointMap = {
  contact: "contact",
  lead: "lead",
  company: "company",
  deal: "deal",
  customers: "customers",
  crm_tasks: "crm_tasks",
};
